var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"margin-top":"73px"}},[_c('div',{staticClass:"mobile-footer",class:{
      'panel-width':
        (_vm.$route.name == 'OTC' && _vm.state.token) ||
        _vm.$route.path.includes('dashboard'),
    }},_vm._l((_vm.mobileLink),function(item,index){return _c('router-link',{key:index,class:{ 'active-link': _vm.$route.name == item.to },attrs:{"to":{ name: item.to }}},[_c('InlineSvg',{staticClass:"icon",attrs:{"src":item.icon}}),_c('span',[_vm._v(_vm._s(item.title))])],1)}),1)])}
var staticRenderFns = []

export { render, staticRenderFns }